import axios from "axios";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationTriangle, LockFill } from "react-bootstrap-icons";
import { notificationActions } from "../../data/notification";
import useT from "../../i18n/useT";
import { getReceiverStatus, formatTimeLeft } from "../../utils/receiver";


const AddReceiver = ({show, setHide, vehicle, onSaved}) => {
    const t = useT();
    const vehicle_id = vehicle && vehicle.id;
    const [formData, setFormData] = useState({
        receiver_fullname: "",
        receiver_identity_number: "",
        receiver_phone: ""
    });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const role = useSelector((state) => state.user.role);
    const isDealer = role === "user" || role === "superviser";

    // Prefill with the existing receiver when editing.
    useEffect(() => {
        if (show && vehicle) {
            setFormData({
                receiver_fullname: vehicle.receiver_fullname || "",
                receiver_identity_number: vehicle.receiver_identity_number || "",
                receiver_phone: vehicle.receiver_phone || "",
            });
        }
    }, [show, vehicle]);

    const status = getReceiverStatus(vehicle);
    // Only dealers are locked out after the window; admins/moderators can always edit.
    const locked = status.locked && isDealer;

    const addReceiverHandler = (e) => {
        e.preventDefault();
        if (locked) return;
        setLoading(true);
        axios.put(`/api/vehicle/${vehicle_id}/receiver`, formData)
            .then((res) => {
                setHide(false);
                if (typeof onSaved === "function") onSaved();
                dispatch(notificationActions.changeNotification({show: true, text: res.data.message.en, type: "success-notification"}));
                setTimeout(() => {
                    dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}));
                }, 4000);
            })
            .catch((err) => {
                const msg = err.response && err.response.data && err.response.data.message ? err.response.data.message.en : "Error";
                dispatch(notificationActions.changeNotification({show: true, text: msg, type: "error-notification"}));
                setTimeout(() => {
                    dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}));
                }, 4000);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return(
        <Modal show={show} onHide={() => setHide(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t("vehicles.addReceiver")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {locked ? (
                    <div className="alert-banner alert-banner-danger" style={{display: "flex", gap: "10px", alignItems: "flex-start", padding: "12px 14px", borderRadius: "10px", background: "rgba(220,53,69,0.12)", color: "#dc3545", marginBottom: "16px"}}>
                        <LockFill style={{flexShrink: 0, marginTop: "2px"}} />
                        <div>
                            <strong>{t("vehicles.receiverLockedTitle")}</strong>
                            <div style={{fontSize: "13px", marginTop: "2px"}}>{t("vehicles.receiverLockedText")}</div>
                        </div>
                    </div>
                ) : (status.deadline && status.required) && (
                    <div className="alert-banner alert-banner-warning" style={{display: "flex", gap: "10px", alignItems: "flex-start", padding: "12px 14px", borderRadius: "10px", background: "rgba(255,159,10,0.14)", color: "#b8690a", marginBottom: "16px"}}>
                        <ExclamationTriangle style={{flexShrink: 0, marginTop: "2px"}} />
                        <div>
                            <strong>{t("vehicles.receiverTimeLeft")}: {formatTimeLeft(status.msLeft, t)}</strong>
                            <div style={{fontSize: "13px", marginTop: "2px"}}>{t("vehicles.receiverReminderText")}</div>
                        </div>
                    </div>
                )}
                <form className="form" onSubmit={addReceiverHandler}>
                    <div className="form-group">
                        <label htmlFor="receiver_fullname">{t("vehicles.receiverFullName")}</label>
                        <input type="text" id="receiver_fullname" value={formData.receiver_fullname} onChange={(e) => setFormData((prev) => ({...prev, receiver_fullname: e.target.value}))} name="receiver_fullname" className="form-control" disabled={locked} required />
                    </div>
                    <div className="form-group mt-4">
                        <label htmlFor="receiver_identity_number">{t("vehicles.receiverIdentityNumber")}</label>
                        <input type="text" id="receiver_identity_number" value={formData.receiver_identity_number} onChange={(e) => setFormData((prev) => ({...prev, receiver_identity_number: e.target.value}))} name="receiver_identity_number" className="form-control" disabled={locked} required />
                    </div>
                    <div className="form-group mt-4">
                        <label htmlFor="receiver_phone">{t("vehicles.receiverPhone")}</label>
                        <input type="text" id="receiver_phone" name="receiver_phone" value={formData.receiver_phone} onChange={(e) => setFormData((prev) => ({...prev, receiver_phone: e.target.value}))} className="form-control" disabled={locked} required />
                    </div>
                    <button type="submit" style={{width: "100%"}} className="btn btn-primary mt-5" disabled={locked || loading}>{t("vehicles.addReceiver")}</button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default AddReceiver;
